/* eslint-disable react-refresh/only-export-components */
import { createContext, type ReactNode, useContext, useState } from "react";

interface LayoutContextType {
	selectedLayout: number;
	setSelectedLayout: (layout: number) => void;
	isShowcaseMode: boolean;
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

interface LayoutProviderProps {
	children: ReactNode;
	isShowcaseMode: boolean;
}

export function LayoutProvider({
	children,
	isShowcaseMode,
}: LayoutProviderProps) {
	const [selectedLayout, setSelectedLayout] = useState<number>(1);

	return (
		<LayoutContext.Provider
			value={{
				selectedLayout,
				setSelectedLayout,
				isShowcaseMode,
			}}
		>
			{children}
		</LayoutContext.Provider>
	);
}

export function useLayout() {
	const context = useContext(LayoutContext);
	if (context === undefined) {
		throw new Error("useLayout must be used within a LayoutProvider");
	}
	return context;
}
